/*
 * @Author: wuchenge
 * @Date:   2022-04-06 18:17:55
 * @Last Modified by:   无尘阁
 * @Last Modified time: 2022-04-06 18:20:34
 */
import { connect } from "react-redux";
import { RecommendWrapper, RecommendItem } from "../style";

const Recommend = ({ list }) => {
  return (
    <RecommendWrapper>
      {list?.map((item) => {
        return (
          <RecommendItem imgUrl={item.get("imgUrl")} key={item.get("id")} />
        );
      })}
    </RecommendWrapper>
  );
};

const mapState = (state) => ({
  list: state.getIn(["home", "recommendList"]),
});

export default connect(mapState, null)(Recommend);
